import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the browser sends + receives the httpOnly `uptick_session`
// cookie that the backend issues on /auth/login + /auth/register.
const api = axios.create({ baseURL: API, withCredentials: true });

// 401 interceptor — redirect to /login on any Unauthorized response,
// but only if we are not already on an auth page (avoids infinite reload loop).
const AUTH_PATHS = ['/login', '/register', '/forgot-password'];
api.interceptors.response.use(
  res => res,
  err => {
    if (
      err.response?.status === 401 &&
      !AUTH_PATHS.some(p => window.location.pathname.startsWith(p))
    ) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
